import { DMSDocumentSignatureStream } from "../../../../Cryptography/Crypto.OW/DMSDocumentSignatureStream";
import { EncryptedDocumentSignatureStream } from "../../../../Cryptography/Crypto.OW/EncryptedDocumentSignatureStream";
import { LocalDocumentSignatureStream } from "../../../../Cryptography/Crypto.OW/LocalDocumentSignatureStream";
import { ICounterSignatureStreams, ISignatureDataStream, ISigningStreamCreator } from "../../../../Cryptography/Crypto/CryptoInterfaces";
import { SignatureStreamSettings } from "../../../../Cryptography/Crypto/SignatureStreamSettings";
import { StringSignatureStream } from "../../../../Cryptography/Crypto/Streams/StringSignatureStream";
import { OWManager } from "../../../../OW.Remoting/Remoting/OWManager";
import { RequestContext } from "../../../../OW.Remoting/Remoting/RequestContext";
import { DownloadManager } from "../DownloadManager";

export class SigningStreamCreator implements ISigningStreamCreator {
    public async createSignatureStreams(settings: SignatureStreamSettings[]): Promise<ISignatureDataStream[]> {
        const streams: ISignatureDataStream[] = [];
        for (const s of settings) {
            streams.push((s.currentFileStream !== null)
                ? new LocalDocumentSignatureStream(s.currentFileStream)
                : this._createDMSDocumentSignatureStream(s));
        }
        return streams;
    }

    private _createDMSDocumentSignatureStream(s: SignatureStreamSettings): ISignatureDataStream {
        const stream: ISignatureDataStream = new DMSDocumentSignatureStream(s.instanceId, s.attrName, (url: string) => DownloadManager.prepareDownload(url, true));
        return s.cryptoKey ? new EncryptedDocumentSignatureStream(stream, s.cryptoKey) : stream;
    }

    public async createCounterSignatureStreams(settings: SignatureStreamSettings[], requestContext?: RequestContext): Promise<ICounterSignatureStreams[]> {
        const streams: ICounterSignatureStreams[] = [];
        for (const s of settings) {
            const documentStream = this._createDMSDocumentSignatureStream(s);
            const signatureStream = s.providerSettings.signatureInsideDocument
                ? documentStream
                : new StringSignatureStream(await OWManager.getDocumentSignature(s.instanceId, s.attrName, requestContext), "--DETACHED_SIGNATURE--", null);
            streams.push({ signatureStream: signatureStream, documentStream: documentStream });
        }
        return streams;
    }
}
